import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { CreateTracLinkSuccess } from '../../../tracpage/action-creators';
import { CREATE_TRAC_LINK_SUCCESS } from '../../../tracpage/actions';

export const trackTraclinkCreated = (
  action$: Observable<CreateTracLinkSuccess>
) =>
  action$.pipe(
    ofType(CREATE_TRAC_LINK_SUCCESS),
    map((action) => {
      if (window.analytics) {
        window.analytics.track('Traclink Created', {
          id: action.tracLink.id,
          title: action.tracLink.title,
          avatar: action.tracLink.data.coverUrl,
          platforms: action.tracLink.links.map((l) => l.platform),
        });
      }
    }),
    filter(() => false)
  );
